export default "__VITE_ASSET__SOxzwv76__"